import { Component, signal, Signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { PatientService } from '../../services/patient.service';
import { Patient } from '../../models/patient.model';
import { ButtonComponent, InputComponent, DateComponent } from '../ui';

@Component({
  selector: 'app-patients',
  imports: [CommonModule, FormsModule, RouterLink, ButtonComponent, InputComponent, DateComponent],
  templateUrl: './patients.component.html',
  styleUrl: './patients.component.css'
})
export class PatientsComponent {
  patients!: Signal<Patient[]>;
  searchQuery = signal('');
  showModal = signal(false);
  editingPatient = signal<Patient | null>(null);
  patientForm = signal<Partial<Patient>>({});
  filteredPatients = signal<Patient[]>([]);

  constructor(private patientService: PatientService) {
    this.patients = this.patientService.getPatients();
  }

  ngOnInit() {
    this.updateFilteredPatients();
  }

  updateFilteredPatients() {
    const query = this.searchQuery().toLowerCase();
    if (!query) {
      this.filteredPatients.set(this.patients());
    } else {
      this.filteredPatients.set(this.patientService.searchPatients(query));
    }
  }

  onSearchChange(query: string) {
    this.searchQuery.set(query);
    this.updateFilteredPatients();
  }

  openAddModal() {
    this.editingPatient.set(null);
    this.patientForm.set({
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      dateOfBirth: new Date(),
      gender: 'Male',
      address: '',
      city: '',
      state: '',
      zipCode: '',
      emergencyContact: {
        name: '',
        phone: '',
        relationship: ''
      }
    });
    this.showModal.set(true);
  }

  openEditModal(patient: Patient) {
    this.editingPatient.set(patient);
    this.patientForm.set({ ...patient });
    this.showModal.set(true);
  }

  closeModal() {
    this.showModal.set(false);
    this.editingPatient.set(null);
  }

  onDateChange(value: string | Date | null) {
    if (value) {
      if (typeof value === 'string') {
        this.patientForm().dateOfBirth = new Date(value);
      } else if (value instanceof Date) {
        this.patientForm().dateOfBirth = value;
      }
    }
  }

  savePatient() {
    const form = this.patientForm();
    if (this.editingPatient()) {
      this.patientService.updatePatient(this.editingPatient()!.id, form);
    } else {
      this.patientService.addPatient(form as Omit<Patient, 'id' | 'createdAt' | 'updatedAt'>);
    }
    this.closeModal();
    this.updateFilteredPatients();
  }

  deletePatient(id: string) {
    if (confirm('Are you sure you want to delete this patient?')) {
      this.patientService.deletePatient(id);
      this.updateFilteredPatients();
    }
  }
}

